<template>
    <div class="form-group">
        <label>Pay with</label>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text input-icon">
                    <i class="fa fa-credit-card"></i>
                </span>
            </div>
            <select v-model="payment"
                    :class="['custom-select', error ? 'is-invalid' : '']">
                <option v-if="currency === 'ZWG'" value="ecocash">EcoCash</option>
                <option value="ecocash-usd">EcoCash USD</option>
                <option value="stripe">International Card</option>
            </select>
            <div v-text="error" class="invalid-feedback"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        payment: {
            type: String,
            default: ''
        },
        currency: {
            type: String,
            default: 'ZWG'
        },
        error: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            internalPayment: this.payment
        };
    },
    watch: {
        payment(newVal) {
            this.internalPayment = newVal;
        },
    },
    methods: {
        updatePayment() {
            this.$emit('update:payment', this.internalPayment);
        },
    },
}
</script>
